
    <div class="refresh" *ngIf="editMode">
      <span class="glyphicon glyphicon-refresh" (click)="refresh()"></span>
    </div>
    <div class="thumbnail" *ngIf="productModel">
      <div *ngIf="!block.data.url">
        <a [routerLink]="['/product/' + block.data.product_id + '.html']">
          <img src="{{productModel?.imageList[0].productImageUrl}}" alt="...">
        </a>
        <div class="caption">
          <h3><a [routerLink]="['/product/' + block.data.product_id + '.html']">{{productModel?.productName}}</a></h3>
          <p>{{productModel?.getSalesPrice()}}</p>
        </div>
      </div>
      <div *ngIf="block.data.url">
        <div *ngIf="block.data.isInternalUrl">
          <a [routerLink]="[block.data.url]">
            <img src="{{productModel?.imageList[0].productImageUrl}}" alt="...">
          </a>
          <div class="caption">
            <h3><a [routerLink]="[block.data.url]">{{productModel?.productName}}</a></h3>
            <p>{{productModel?.getSalesPrice()}}</p>
          </div>
        </div>
        <div *ngIf="!block.data.isInternalUrl">
          <a href="{{block.data.url}}">
            <img src="{{productModel?.imageList[0].productImageUrl}}" alt="...">
          </a>
          <div class="caption">
            <h3><a target="_blank" href="{{block.data.url}}">{{productModel?.productName}}</a></h3>
            <p>{{productModel?.getSalesPrice()}}</p>
          </div>
        </div>
      </div>
    </div>
  